import { render, staticRenderFns } from "./psuBmFile.vue?vue&type=template&id=fbd0c766&scoped=true"
import script from "./psuBmFile.vue?vue&type=script&lang=js"
export * from "./psuBmFile.vue?vue&type=script&lang=js"
import style0 from "./psuBmFile.vue?vue&type=style&index=0&id=fbd0c766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd0c766",
  null
  
)

export default component.exports